export const dialogActionStyle = {
  display: "flex",
  gap: "0.25rem",
  paddingRight: "20px",
};
